import apiHandler from "../core/apiHandler";

/**
 * ⚙️ QZ Tray Configuration API
 * 
 * Maneja todas las peticiones relacionadas con la configuración
 * del módulo QZ Tray (host, puerto, protocolo, sucursal, etc.).
 * 
 * ✅ Endpoints principales:
 * - GET /api/qztray/config/active → Obtener configuración activa
 * - GET /api/qztray/config/list → Listar todas las configuraciones
 * - POST /api/qztray/config/save → Guardar o actualizar configuración
 * - POST /api/qztray/config/test → Probar conexión con QZ Tray
 */
const qzTrayConfigurationApi = apiHandler("qztray/config");

export default qzTrayConfigurationApi;
